<mat-progress-bar *ngIf="loaderService?.loading" color="warn" mode="indeterminate" class="position-absolute">
</mat-progress-bar>

<mat-toolbar fxLayout="row" fxFlex color="primary" class="w-100 header-toolbar">
  <div *ngIf="false">
    <button (click)="openDrawer()" mat-icon-button>
      <mat-icon>{{ isOpened ? "menu_open" : "menu" }}</mat-icon>
    </button>
  </div>

  <!-- <div fxFlex="70" class="logo">
    <a routerLink="/main" target="_self" tabindex="0">
      <dg-file-upload
        class="file-upload"
        [title]="''"
        [profileAttachment]="true"
        [uniqueAttachmentId]="profileUniqueAttachID"
        [allowFileToAttach]="false"
        [signatureBox]="true"
        [refreshAttachComponent]="false"
        [defaultImagePath]="'./assets/images/header-page-logo.png'"
        [attachId]="headerLogoId"
      >
      </dg-file-upload>
    </a>
  </div> -->
  <div fxFlex="80" class="logo">
    <a routerLink="/main" target="_self" tabindex="0">
      <img alt="DigiGOV logo" title="DigiGOV" src="../../../../assets/images/cfmsLogo.png" style="height: 60px;
        width: auto;" />

    </a>
  </div>


  <div class="position-relative environment me-4" *ngIf="false">
    <app-dg-environment-details></app-dg-environment-details>
  </div>
  <div class="position-relative environment">
    <button mat-button (click)="buildDetails()" style="cursor: pointer;">
      Build Details
    </button>
  </div>

  <!-- <div class="position-relative environment">
    <button mat-button (click)="contactDetails()" class="blink-button">
      Verify Contact
    </button>
  </div> -->

  <!-- search-box.component.html  -->
  <div *ngIf="false" class="search-container" [ngClass]="{ expanded: isExpanded }">
    <mat-icon (click)="expandSearchBox()" class="notification1">
      search
    </mat-icon>
    <div *ngIf="isExpanded" class="search-dropdown">
      <div fxFlex="22" class="search-drop">
        <input sanitized matinput [formControl]="search" class="form-control me-sm-2" type="search"
          placeholder="Search Anything " aria-label="Search" />
        <div fxFlex="5" class="mt-1" id="searchicon">
          <mat-icon class="search12"> search </mat-icon>
        </div>
      </div>
      <!-- <input type="text" id="searchBox" placeholder="Search" /> -->
    </div>
  </div>

  <div fxFlex="22" class="dg-searchbox" *ngIf="false">
    <input sanitized matinput [formControl]="search" class="form-control me-sm-2" type="search"
      placeholder="Search Anything & Everything..." aria-label="Search" />

    <div fxFlex="5" class="mt-1" id="searchicon">
      <mat-icon> search </mat-icon>
    </div>
  </div>
  <!-- hgggffg -->
  <div fxFlex class="env-heading" *ngIf="false">
    <p>{{ env }}</p>
  </div>

  <div class="pe-4" [matMenuTriggerFor]="menu1" *ngIf="false">
    <button mat-icon-button matTooltip="Alerts" aria-label="Alerts">
      <mat-icon [matBadge]="headerService.getCount()" [matBadgeHidden]="headerService.getCount() === 0"
        matBadgeColor="accent" class="notification">notifications_none</mat-icon>
    </button>
  </div>

  <!-- <mat-menu
    #menu1="matMenu"
    class="custom-menu notification-menu"
    [overlapTrigger]="false"
  >
    <div class="notification-box">
      <span class="dg-txt-primary dg-h-15">Alerts</span>
      <ng-template matMenuContent>
        <app-dg-notifypop></app-dg-notifypop
      ></ng-template>
      <div class="notification-footer text-center top-shadow">
        <button
          mat-button
          (click)="goToIntimations()"
          class="dg-btn mt-2 notification-view-btn"
        >
          <div class="view">View All</div>
          <div class="show">Show More</div>
        </button>
      </div>
    </div>
  </mat-menu> -->
  <div class="cursor-pointer">
    <dg-file-upload class="file-upload" [title]="profileAttachTitle" (finalPath)="onFinalPathForProfile($event)"
      [profileAttachment]="isProfileComponent" [acceptedType]="" [maxSize]="" [uniqueAttachmentId]=""
      [allowFileToAttach]="isAllowFileToAttachProfile" [allowDelete]="isAllowDelete" [matMenuTriggerFor]="menu"
      (menuOpened)="menuOpened()" cursor="pointer" [defaultImagePath]="'./assets/images/home-emp-logo.png'">
    </dg-file-upload>
  </div>

  <mat-card role="group" tabindex="0" class="card-no-border post-card cursor-pointer" [matMenuTriggerFor]="menu">
    <div class="px-3 menu11">
      <div class="dg-txt-white dg-h-16 mb-0">{{ empfullName }}</div>
      <div class="dg-txt-white dg-fs-12 mb-0" *ngIf="empDsgnName">
        {{ empDsgnName }}
      </div>
    </div>
  </mat-card>
  <mat-menu #menu="matMenu" [overlapTrigger]="false">
    <ng-container *ngIf="singlePost">
      <mat-card class="card-no-border container dg-btn">
        <span class="mat-body dg-txt-primary dg-fs-12"> Current Post : </span><br />
        <span class="mat-body-strong">{{ singlePost }}</span><br />
      </mat-card>
      <mat-divider></mat-divider>
    </ng-container>

    <ng-container *ngIf="showSwitchPost">
      <mat-card class="card-no-border container dg-btn">
        <span class="mat-body dg-txt-primary dg-fs-12"> Current Post : </span><br />
        <span class="mat-body-strong"> {{ currentPost }} </span><br />
        <button mat-flat-button class="switch-post" color="primary" (click)="openSwitchPost('button')" cursor="pointer">
          Switch Post
        </button>
      </mat-card>
      <mat-divider></mat-divider>
    </ng-container>
    <ng-container *ngIf="appInitService?.appConfig?.authType !== 'oauth2'">
      <mat-card class="card-no-border">
        <span class="mat-body dg-txt-primary dg-fs-12"> Last Login : </span><br />
        <span class="mat-body-strong">{{ lastLogin | date: "medium" }} </span><br />

        <ng-container *ngIf="pwdExpiry">
          <span class="mat-body dg-txt-primary dg-fs-12">
            Password Expiry : </span><br />
          <span class="mat-body-strong">
            {{ pwdExpiry | date: "medium" }}
          </span> </ng-container><br />
        <ng-container *ngIf="
            appInitService?.appConfig?.showSessionChecker &&
            (sessionRemainingTime$ | async) > -1
          ">
          <span class="mat-body dg-txt-primary dg-fs-12">
            Session Expiry : </span><br />
          <span class="mat-body-strong">
            {{ minutes | number: "2.0-0" }}:{{ seconds | number: "2.0-0" }}
          </span>
        </ng-container>
      </mat-card>
      <mat-divider></mat-divider>
    </ng-container>
    <button mat-menu-item *ngIf="showUserButton" (click)="goToUserProfile()">
      My Profile
    </button>
    <button mat-menu-item (click)="goToNewSettings()">Settings</button>
    <button mat-menu-item *ngIf="
        isPasswordChangeAllowed &&
        appInitService?.appConfig?.authType !== 'wso2'
      " (click)="goToChangePassword()">
      Change Password
    </button>

    <button mat-menu-item [disabled]="true">Help</button>
    <button mat-menu-item *ngIf="showUserButton" (click)="logout()" cursor="pointer">
      Logout
    </button>
  </mat-menu>

  <!-- start for mobile screen -->
  <mat-divider></mat-divider>

  <button mat-icon-button [matMenuTriggerFor]="dropMenu" fxHide fxShow.md>
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #dropMenu="matMenu" class="headerMenu">
    <button mat-menu-item>
      <button mat-button>
        <mat-icon [matBadge]="headerService.getCount()" matBadgeColor="warn">notifications_outline</mat-icon>
        Notifications
      </button>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item></button>

    <mat-divider></mat-divider>
    <button mat-menu-item>
      <button mat-button *ngIf="showUserButton" (click)="goToUserProfile()">
        <mat-icon>perm_identity</mat-icon>User Profile
      </button>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item>
      <button mat-button (click)="logout()">
        <mat-icon>logout</mat-icon>Logout
      </button>
    </button>
  </mat-menu>
  <!-- end for mobile screen -->
</mat-toolbar>

<div *ngIf="showPasswordExpireMessageBanner" class="row password-expire-reminder-banner py-2 d-none">
  <div class="col-md-11 align-self-center">
    <span class="text-center d-block">
      Your password is about to expire in
      <strong>{{ pwdExpireDayCount }} days</strong>.
    </span>
    <span class="text-center d-block">
      To change it now
      <a class="cursor-pointer" tabindex="0" (keydown.enter)="goToChangePassword()" (click)="goToChangePassword()">
        click here
      </a>
      or go to Profile> Change Password.
    </span>
  </div>
  <div class="col-md-1 align-self-center">
    <button mat-stroked-button class="dismiss-button" (click)="showPasswordExpireMessageBanner = false">
      {{ "dismiss" | titlecase }}
    </button>
  </div>
</div>
<!-- SESSION CHECKER DIALOG -->
<ng-template #sessionAlert>
  <h1 mat-dialog-title class="dg-txt-primary">Session Alert</h1>
  <mat-dialog-content>
    <div class="row">
      <div class="d-flex justify-content-center align-items-center dg-fs-16">
        You will be logged out after
        <span class="m-2 minutes countDown">
          {{ minutes | number: "2.0-0" }}
        </span>
        <span>Minutes</span>
        <span class="m-2 seconds countDown">
          {{ seconds | number: "2.0-0" }}
        </span>
        <span class="me-2">Seconds</span>
        of inactivity.
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close (click)="hideCountDownTimer()">
      Close
    </button>
    <button cdkFocusInitial mat-raised-button class="ms-2" color="primary" mat-dialog-close (click)="continueSession()">
      Continue
    </button>
  </mat-dialog-actions>
</ng-template>
<ng-template *ngIf="sessionStatus$ | async"></ng-template>